'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { trackEvent } from '@/lib/analytics/gtm';

function featureFromPath(path: string): string {
  if (path === '/') return 'homepage';
  if (path.startsWith('/about')) return 'about';
  if (path.startsWith('/contact')) return 'contact';
  if (path.startsWith('/resources')) return 'resource-listing';
  return 'landing-page';
}

export function RouteChangeTracker() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackEvent({
      feature: featureFromPath(pathname),
      action: 'route_change',
      params: { page_path: pathname },
    });
  }, [pathname]);

  return null;
}
